export default __webpack_public_path__ + "static/media/s4img1.9b6a5472.webp";